<template>
  <b-container>
    <SiteTabs />
    <b-row>
      <b-col class="text-center all-caps">
        <h1>
          MEDIA CONTACT
        </h1>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <p>
          Feel free to get in touch anytime. Email us with questions or inquiries you have. We would be happy to answer any questions and schedule a meeting/call.
        </p>

        <p>
          <strong>Media Contact Information</strong><br>
          <strong>Email: </strong><a href="mailto:press@songback.com">press@songback.com</a><br>
          <br>
          Songback, LLC <br>
          P.O. Box 18011 <br>
          Irvine, CA 92623 <br>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="scss">
  h1 {
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 1.5rem;
  }

  .all-caps {
    text-transform: uppercase;
  }
</style>

<script>
import SiteTabs from '@/components/widgets/SiteTabs'

export default {
  components: {
    SiteTabs
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/site/Press.vue